// TierBadge v0.1.0 — small inline T1/T2 marker rendered between the provider
// name and the `?` description button. Distinguishes T1 ("high priority,
// significant standalone outages possible") from T2 ("category provider,
// outages usually tied to a tier-0 dependency"). T0 doesn't need a badge —
// the entire TIER 0 strip already announces it.
//
// Visual design: monospace, subdued grey-on-grey pill so it informs without
// competing with the bright-white name or the bright-yellow `?`. T1 is given
// slightly more visual weight (border-accent/40) than T2 because the rule of
// thumb is "T1 outages tend to surprise people".
interface Props {
  tier: number;
}

export default function TierBadge({ tier }: Props) {
  if (tier !== 1 && tier !== 2) return null;
  const label = `T${tier}`;
  const cls = tier === 1 ? 'border-accent/40 text-accent/80' : 'border-border text-dim';
  return (
    <span
      aria-label={`Tier ${tier}`}
      className={`inline-flex items-center justify-center px-1 py-0 rounded-sm border text-[9px] font-mono leading-none tracking-tight shrink-0 ${cls}`}
    >
      {label}
    </span>
  );
}
